// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ChangeProductQtyForExistingProduct,
} from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/AddProduct";
import { xDefaultRules } from "@tps/XDL/Utilities";

let maxQty: number;
xDefaultRules["qty"].split("|").forEach(item => {
    const [attr, val] = item.split(":");
    if (attr === "max") {
        maxQty = +val;
    }
}, {});

export const XngChangeProductQtyForExistingProduct: typeof ChangeProductQtyForExistingProduct = props => {
    const quickOrderProductInfos = props.getState().pages.quickOrder.productInfos;
    const { productId, qtyOrdered, unitOfMeasure } = props.productInfo;
    const existingProductInfo = quickOrderProductInfos.find(
        o => o.productId === productId && o.unitOfMeasure === unitOfMeasure,
    );
    if (!existingProductInfo) {
        return;
    }
    // XNG-Changes
    // OOTB fix: sum of quantities greater than or equal to maxQty
    const totalQtyOrdered = existingProductInfo.qtyOrdered + qtyOrdered;

    if (totalQtyOrdered >= maxQty) {
        props.productInfo.qtyOrdered = maxQty;
    } else {
        props.productInfo.qtyOrdered = totalQtyOrdered;
    }
};
replaceInChain(chain, ChangeProductQtyForExistingProduct, XngChangeProductQtyForExistingProduct);
